import { domToBlob } from 'modern-screenshot';

/** Best-effort root for feedback screenshots (main column, else inset, else body). */
export function pickFeedbackCaptureRoot(): HTMLElement {
  const content = document.querySelector<HTMLElement>(
    '[data-slot="app-main-content"]',
  );
  if (content && elementHasPaintableSize(content)) {
    return content;
  }
  const inset = document.querySelector<HTMLElement>(
    '[data-slot="sidebar-inset"]',
  );
  if (inset && elementHasPaintableSize(inset)) {
    return inset;
  }
  return document.body;
}

function elementHasPaintableSize(el: HTMLElement): boolean {
  const r = el.getBoundingClientRect();
  const w = Math.max(r.width, el.scrollWidth);
  const h = Math.max(r.height, el.scrollHeight);
  return w >= 4 && h >= 4;
}

/** Capture a JPEG blob of the current page content for feedback. Returns null on failure. */
export async function captureFeedbackScreenshot(): Promise<Blob | null> {
  try {
    const root = pickFeedbackCaptureRoot();
    const blob = await domToBlob(root, {
      type: 'image/jpeg',
      quality: 0.85,
      scale: Math.min(window.devicePixelRatio, 2),
    });
    return blob && blob.size > 0 ? blob : null;
  } catch {
    return null;
  }
}
